// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  // Scheduled maintenance banner. Flip `enabled` to true and set the window.
  // Times are JST in simple 'YYYY-MM-DD HH:mm' format. The banner is shown to
  // every visitor until `to` has passed, then it hides itself automatically.
  maintenance: {
    enabled: true,
    from: '2026-07-11 22:00',
    to: '2026-07-12 04:00'
  },
  firebase: {
    apiKey: "AIzaSyDIRn7Lq4Xf7hX9-9LsgC94Vqr8V7QYf0M",
    authDomain: "mtc-filetransfer.firebaseapp.com",
    databaseURL: "https://mtc-filetransfer.firebaseapp.com",
    projectId: "mtc-filetransfer",
    storageBucket: "mtc-filetransfer.appspot.com",
    messagingSenderId: "184320802582"
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
